import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../tooltip';
import { Textarea } from '../../textarea';
import { cn } from '../../../lib/utils';

export function AltTextInput(props: {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	tooltipText?: string;
	readOnly: boolean;
}) {
	const defaultPlaceholder = props.placeholder ?? 'Describe this image for accessibility';

	if (props.readOnly && !props.value) return null;

	return (
		<div
			className={cn(
				'flex items-start gap-1.5 rounded-lg border px-2 py-1.5 transition-[border-color,opacity]',
				props.readOnly ? 'border-transparent' : 'border-border border-dashed',
			)}
		>
			<TooltipProvider>
				<Tooltip>
					<TooltipTrigger asChild>
						<span
							className={cn(
								'text-muted-foreground shrink-0 rounded px-1.5 py-1 font-mono text-[9px] leading-none font-medium cursor-help bg-black/5',
							)}
						>
							ALT
						</span>
					</TooltipTrigger>
					<TooltipContent side="top" className="max-w-64">
						{props.tooltipText ??
							'Describe the content for screen readers. It improves accessibility and search engine optimization (SEO).'}
					</TooltipContent>
				</Tooltip>
			</TooltipProvider>
			<Textarea
				variant="ghost"
				value={props.value}
				onChange={(e) => props.onChange(e.target.value)}
				placeholder={defaultPlaceholder}
				rows={1}
				readOnly={props.readOnly}
				tabIndex={props.readOnly ? -1 : undefined}
				className={cn(
					'text-xs! leading-snug transition-colors',
					props.readOnly ? 'text-muted-foreground italic resize-none' : 'placeholder:text-muted-foreground/70',
				)}
			/>
		</div>
	);
}
